<template>
    <div>
        <div v-if="successMessage" class="text-center mt-2 text-success">
            {{ successMessage }}
        </div>
        <div v-if="!supplier.invoice_bank_number" class="bg-danger text-white p-3" style="border-radius: 5px;">
            <div class="row mt-2">
                <div class="col-md-2">
                    <div class="mb-2 font-weight-bold">
                        <i class="fa fa-exclamation-circle fa-2x ml-3"></i>
                    </div>
                </div>
                <div class="col-md-10">
                    <div class="mb-2 font-weight-bold">
                        Kontonummer mangler
                    </div>
                    <p class="mb-3">
                        Fyll ut for å motta utbetalinger
                    </p>
                    <div class="form-group row">
                        <div class="col-md-10">
                            <input
                                type="text"
                                required
                                class="form-control"
                                placeholder="Skriv inn kontonummer"
                                v-model="bankNumberInput"
                            />
                            <div v-if="errorMessage">
                                <div style="font-size: 12px;" class="mt-1">
                                    <i>{{ errorMessage }}</i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button class="btn btn-light btn-sm" style="background-color: white;" @click="submitBankNumber">
                        Send inn
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';
import {suppliers} from "@/api";

export default {
    props: {
        supplier: {
            type: Object,
            required: true,
        },
    },
    computed: {
        ...mapGetters({
            user: 'auth/getUser',
        }),
    },
    data() {
        return {
            bankNumberInput: '',
            show: true,
            errorMessage: null,
            successMessage: null
        };
    },
    methods: {
        submit(evt) {
            evt.preventDefault();
            alert(JSON.stringify(this.form));
        },
        onReset(evt) {
            evt.preventDefault();
            this.bankNumberInput = '';
            this.show = false;
            this.$nextTick(() => {
                this.show = true;
            });
        },
        async submitBankNumber() {
            if (this.bankNumberInput.length !== 11) {
                this.errorMessage = "Obs! Kontonummeret må ha 11 sifre.";
                return;
            }
            this.errorMessage = null;

            try {
                await suppliers.updateInvoiceBankNumber(
                    this.supplier.id,
                    this.bankNumberInput
                );
                this.supplier.invoice_bank_number = this.bankNumberInput;
                this.successMessage = 'Banknummer oppdatert!';
            } catch (error) {
                this.errorMessage = 'Feil under oppdatering av banknummer!'
            }
        },
    },
};
</script>
